/* eslint-disable react-refresh/only-export-components */
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

interface MobileSidebarContextValue {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
}

const MobileSidebarContext = createContext<
  MobileSidebarContextValue | undefined
>(undefined);

export interface MobileSidebarProviderProps {
  children: ReactNode;
}

export function MobileSidebarProvider({
  children,
}: MobileSidebarProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = {
    isOpen,
    toggle,
    close,
  };

  return (
    <MobileSidebarContext.Provider value={value}>
      {children}
    </MobileSidebarContext.Provider>
  );
}

// Hook can be in same file since it's tightly coupled to the context
export function useMobileSidebar() {
  const context = useContext(MobileSidebarContext);

  if (context === undefined) {
    throw new Error(
      'useMobileSidebar must be used within a MobileSidebarProvider'
    );
  }

  return context;
}
